<template>
    <div class="home" :style="{height:screenHeight + 'px',width:screenWidth +'px'}">
        <img src="../../static/home.png" mode="bottom left" style="width:100%;height:100%">
        <div class="hdBackground" v-show="backHome"></div>
        <div class="hd" v-show="backHome">
            选择您要定制的百工人物形象
        </div>
        <div class="bd" v-show="backHome">
            <div v-for="(item,index) in roleList" :key="index" class="showRole" @click="goDetail(index)">
                <div class="roleBackground"></div>
                <img :src="item.img" class="roleImg">
                <div style="font-family: 'jxzhuokai';position: absolute;left: 5%;top: 15%;font-size: 2rem;">{{ item.role}}</div>
            </div>
        </div>
        <div class="showDetail" v-if="openDetail == true">
            <div style="position:relative;width:100%;height:100%">
                <div class="detailBackground"></div>
                <van-swipe lazy-render class=" content" :show-indicators="false" ref="swipe"  @change="onChange" :loop="true"
                    :initial-swipe="ckIndex">
                    <van-swipe-item v-for="item in roleList" :key="item.id">
                        <img :src="item.img" alt="" style="width: 100%;height: 80%;">
                        <div class="content_text">
                            <div style="font-size:2rem;font-family: 'jxzhuokai'">{{ item.introduce}}</div>
                        </div>
                        <div class="fl_text">{{item.role}}</div>
                    </van-swipe-item>
                </van-swipe>
                <div class="fl_remove_first" @click="backIndex">
                    <img src="../../static/u11.png" style="width:5rem;height: 5rem;">
                </div>
                <!-- <div class="fl_left" @click="goLast">
                    <img src="../../static/u54.png" style="width:80%;height: 80%;margin-right: 10px;">
                </div>
                <div class="fl_right" @click="goNext">
                    <img src="../../static/u54.png"
                        style="width:80%;height: 80%;margin-left: 10px;transform: rotateY(180deg);">
                </div> -->
                <div class="btnBackground"></div>
                <div class="btn_start" @click="openCamera">
                    滑动选择喜欢的人物<br>比ok开启互动之旅
                </div>
            </div>

        </div>
        <div class="getPhoto" v-if="getphoto">
            <div style="position:absolute;width:100%;height:100%">
                <div class="roleBackground_photo"></div>
                <div class="content_photo">
                    <img :src="yourface" alt="" style="width: 100%;height: 80%;">
                    <div class="content_text">
                        <div style="font-size:2rem;font-family: 'jxzhuokai'">{{ roleList[sureIndex-1].introduce}}
                        </div>
                    </div>
                    <div class="fl_text">{{ roleList[sureIndex-1].role}}</div>
                </div>
                <div class="introduceBackground">
                </div>
                <div class="getintroduceText">
                    <div style="font-size:3rem;font-family: 'jxzhuokai';text-align: center;" @click="back">已为您生成专属形象
                    </div>
                    <div style="font-size:3rem;font-family: 'jxzhuokai';text-align: center;" @click="forward">
                        确认形象做出“ok”手势</div>
                    <div style="font-size:3rem;font-family: 'jxzhuokai';text-align: center;">返回重做请抬手做出“向左滑”手势</div>
                </div>
            </div>
        </div>
        <div class="getPhoto" v-if="surephoto">
            <div style="position:absolute;width:100%;height:100%">
                <div class="roleBackground_photo"></div>
                <div class="content_photo">
                    <img :src="yourface" alt="" style="width: 100%;height: 80%;">
                    <div class="content_text">
                        <div style="font-size:2rem;font-family: 'jxzhuokai'">{{ roleList[sureIndex-1].introduce}}
                        </div>
                    </div>
                    <div class="fl_text">{{ roleList[sureIndex-1].role}}</div>
                </div>
                <div class="introduceBackground1">
                </div>
                <div class="getintroduceText">
                    <div style="font-size:4rem;font-family: 'jxzhuokai';text-align: center;margin-top: 20px;">已为您生成专属形象</div>
                </div>
            </div>
        </div>
        <div>
            <mediapipe @victory="victory" @take-photo="takePhoto" @back="back" @forward="forward"  @okay="okay" ref="mediapipeRef" :pose-listens="poseListens" :hands-listens="handsListens" :class="goCamera == true ? 'takePhoto':'selectUser'">
            </mediapipe>
        </div>
        <div style="width: 100vw;height: 100vh;position: fixed;top: 0;z-index: 104;" v-show="goCamera">
            <div style="width:100%;height:100%">
                <img src="../../static/cameraBackground.png" style="width:100%;height:100%">
            </div>
        </div>
        <div style="width: 100vw;height: 100vh;position: fixed;top: 0;z-index: 104;" v-show="showQRcode">
            <div
                style=" background-color: rgb(129, 129, 129);  opacity: 0.7; flex: 1;width:100%;height: 100%;position: relative;">
            </div>
            <div class="qrCodeShow">
                <vue-qr :text="yourface" style="width:25rem;height:25rem;margin: 40px 0;"></vue-qr>
                <div>
                    <div style="font-size:2rem;font-family: 'jxzhuokai';text-align: center;">拿出手机，扫一扫二维码</div>
                    <div style="font-size:2rem;font-family: 'jxzhuokai';text-align: center;">即可获得图片并生成分享链接</div>
                    <div style="font-size:2rem;font-family: 'jxzhuokai';text-align: center;">({{count}}秒后自动关闭)</div>
                </div>
                <div style="width:7rem;height: 7rem;margin-top: 10px;" @click="showQRcode = false">
                    <img src="../../static/u11.png" style="width:100%;height: 100%;">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Swipe, SwipeItem, } from 'vant';
import mediapipe from '@/views/components/mediapipe'
import { Toast } from 'vant';
import { saveFaceImage } from '@/api'
import VueQr from 'vue-qr'
export default {
    components: {
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        [Toast.name]: Toast,
        mediapipe,
        VueQr
    },
    data() {
        return {
            backHome:true,
            openDetail: false,
            ckIndex: 10,
            goCamera: false,
            getphoto: false,
            surephoto: false,
            showQRcode:false,
            sureIndex:10,
            count:0,
            victoryNum:0,
            timer:null,
            roleList: [
                {
                    id: 1,
                    role: '编草扇',
                    img: require('../../static/role21.png'),
                    introduce: '采用九板桥村当地所产的草本植物作原料，选取草本植物中柔韧的秆、皮、芯、叶、根，竖经横纬，纯手工通过编、结、辫、扣、扎、绞、缠、网、串、盘等丰富的手法和编结技法，编织成草扇。'
                },
                {
                    id: 2,
                    role: '滚京团',
                    img: require('../../static/role1.png'),
                    introduce: '采用糯米粉和生粉和到团，再分成若干小团，搓圆，放入沸水中煮熟。捞出，放入熟豆粉（炒熟的黄豆或玉米碾成粉）、熟芝麻、红糖拌匀成为“豆黄”中反复粘沾，做成粘粉带糖滚芝麻的滚京团。'

                },
                {
                    id: 3,
                    role: '砌墙磡',
                    img: require('../../static/role3.png'),
                    introduce: '河边的石砌墙，叫做“石磡”，石磡按照纵联砌置法构筑而成，或设置石耳，用来拴小船，或设有埗头，方便村民挑水、洗涤，以及运载货物时上下河涌。而岸上每条巷口对开会或设有穿过石砌墙的用于排放污水的水渠口。'
                },
                {
                    id: 4,
                    role: '凿碗字',
                    img: require('../../static/role4.png'),
                    introduce: '先将字样描写在碗底，通过一把凿子和一把锤子，依笔迹的每一笔横竖撇捺折笔划都凿上一个个连续的的洞，按指定字样凿在碗底后，再用破布蘸墨一擦，然后把字的周围清洗干净，墨迹就深入到凿出来的字上了，永远不会褪色。'
                }
            ],
            yourface:'',
            screenWidth:0,
            screenHeight:0,
            
        }
    },
    mounted(){
        window.screenWidth = document.body.clientWidth;
        window.screenHeight = document.documentElement.clientHeight;
        this.screenWidth = window.screenWidth;
        this.screenHeight = window.screenHeight;
    },
    computed:{
        poseListens(){
            if(this.goCamera == true){
                return []
            } else if(this.backHome == true){
                return []
            }
        },

        handsListens(){
            if(this.backHome == true){
                return []
            }
        }
    },
    methods: {
        onChange(index){
            this.ckIndex = index
        },
        goDetail(index) {
            this.backHome = false
            this.openDetail = true
            this.ckIndex = index
            console.log(this.ckIndex)
        },
        goLast() {
            this.$refs.swipe.next()
        },
        goNext() {
            this.$refs.swipe.prev()

        },
        backIndex() {
            this.openDetail = false
            this.backHome = true
        },
        victory() {
            // Toast('胜利！！')
             if(this.goCamera == true && this.victoryNum < 5){
                this.victoryNum ++
            }else if (this.goCamera == true && this.victoryNum >= 5) {
                this.victoryNum = 0
                this.takePhoto()
            }
        },
        okay(){
            // Toast('Okay！')
            if (this.goCamera == false && this.getphoto == false && this.surephoto == false) {
               this.goCamera = true
            } else if (this.goCamera == false && this.getphoto == true) {
                this.getphoto = false
                this.surephoto = true
                this.showQRcode = true
                this.getTime()
            }

        },
        openCamera(){
            this.goCamera = true
        },
        takePhoto(blob) {
            const _this = this
            _this.sureIndex = _this.ckIndex + 1
            console.log("sureIndex",_this.sureIndex)
            _this.$refs.mediapipeRef.takePhoto().then(blob => {
                const formData = new FormData()
                formData.append('file', blob)
                formData.append('select_id', _this.sureIndex)
                saveFaceImage(formData).then(res => {
                    Toast('照片上传成功！')
                    _this.yourface = res.data.url
                     _this.goCamera = false
                    _this.openDetail = false
                     _this.getphoto = true

                })
            })
        },
        back() {
            Toast('左划！')
            console.log(this.goCamera)
            console.log(this.getphoto)
            if  (this.goCamera == false && this.getphoto ==false) {
                this.goLast()
            } else if (this.goCamera == true && this.getphoto == false) {
                 this.goCamera = false
            } else if (this.goCamera == false && this.getphoto == true) {
                this.getphoto = false
                this.backHome = true
            }
        },
        forward() {
            Toast('右滑！')
            if (this.goCamera == false && this.getphoto == false) {
                this.goNext()
            }
        },
        getTime(){
            if(this.surephoto == true && this.showQRcode == true){
                this.count = 60
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= 60) {
                        this.count--;
                    } else {
                        this.showQRcode =  false
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000)
            }
            }
        }
    }
</script>
<style scoped>



.home {
    box-sizing: border-box;
    padding: 20px 0;
    opacity: 1;
    background: transparent url('../../static/homeBackground.png') 0% 0% padding-box;
    background-size: 100%;
    position: relative;
}

.hdBackground {
    width: 90%;
    height: 13rem;
    box-sizing: border-box;
    position: absolute;
    top: 5%;
    background-color: #FFFFFF;
    opacity: 0.7;
    right: 5%;
    border-radius: 10px;
}

.hd {
    font-size: 4rem;
    text-align: center;
    margin-top: 1rem;
    font-family: 'jxzhuokai';
    position: absolute;
    top: 5%;
    right: 5%;
    width: 90%;
    padding: 0 12rem;
    box-sizing: border-box;
}

.bd {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    position: absolute;
    bottom: 2rem;
    padding-left:1rem ;

}


.showRole {
    width:40%;
    height: 40rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 4.5rem;
    position: relative;

}

.fl_remove_first {
     position: absolute;
    top:6rem;
    right:4rem;
}

.roleBackground {
    width: 90%;
    height: 80%;
    position: absolute;
    background-color: #FFFFFF;
    opacity: 0.7;
    top: 10%;
    left: 5%;
    border-radius: 15px;
}
.roleImg {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 5%;
    left: 5%;

}

.showDetail {
    width: 100vw;
    height: 100vw;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 0;
}

.detailBackground {
    width: 85%;
    height: 100%;
    position: absolute;
    background-color: #FFFFFF;
    opacity: 0.7;
    top: 6rem;
    left: 10%;
    border-radius: 15px;
}
.content {
    width: 90%;
    height:70rem;
    box-sizing: border-box;
    border-radius: 15px;
    position: absolute;
    top: 5rem;
    left: 6%;
    padding: 0 2rem;
}

.content_text {
    box-sizing: border-box;
    padding: 0 1rem;
    font-family: 'jxzhuokai';
    box-sizing: border-box;
    margin-right: 0.5rem;
}

.btnBackground {
    position: absolute;
    width: 85%;
    height: 16rem;
    background-color: #FFFFFF;
    opacity: 0.7;
    top: 90rem;
    left: 10%;
    border-radius: 15px;

}
.btn_start {

    width: 85%;
    height: 8rem;
    font-size: 5rem;
    text-align: center;
    line-height: 8rem;
    position: absolute;
    top: 90rem;
    font-family: 'jxzhuokai';
    right: 7%;
}

.fl_remove {
    position: absolute;
    top:3rem;
    right:3rem;
}

.fl_left {
    position: absolute;
    width: 55px;
    height: 55px;
    background-color: rgba(255, 255, 255, 1);
    overflow: hidden;
    border-radius: 50%;
    border: 1px solid #898787b3;
    top: 32%;
    left: 20px;
    text-align: center;
    box-sizing: border-box;
    padding-top: 6px;
    /* margin-left: -30px; */

}

.fl_right {
    position: absolute;
    width: 55px;
    height: 55px;
    background-color: rgba(255, 255, 255, 1);
    overflow: hidden;
    border-radius: 50%;
    border: 1px solid #898787b3;
    top: 32%;
    right: 20px;
    text-align: center;
    box-sizing: border-box;
    padding-top: 6px;
    /* margin-right: -30px; */
}

.fl_text {
    position: absolute;
    font-size: 4rem;
    font-weight: bold;
    margin: 0 auto;
    width: 15rem;
    top: 5rem;
    left: 5rem;
    font-family: 'jxzhuokai'
}

.takePhoto {
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index:102;
    opacity: 1;
}

.getPhoto {
    width: 100vw;
    height: 100vh;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 0;
}

.content_photo {
    width: 90%;
        height: 80rem;
        box-sizing: border-box;
        border-radius: 15px;
        position: absolute;
        top:0%;
        left: 5%;
}

.roleBackground_photo {
    width: 90%;
    height: 65%;
    position: absolute;
    background-color: #FFFFFF;
    opacity: 0.7;
    top: 3%;
    left: 5.5%;
    border-radius: 15px;
}

.introduceBackground {
    width: 90%;
    height: 15rem;
    position: absolute;
    background-color: #FFFFFF;
    opacity: 0.7;
    bottom: 8%;
    left: 5.5%;
    border-radius: 15px;
}

.getintroduceText {
    width: 90%;
    position: absolute;
    bottom: 9%;
    left: 5.5%;
    padding: 10px 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 1rem;
}

.introduceBackground1 {
    width: 90%;
    height: 10rem;
    position: absolute;
    background-color: #FFFFFF;
    opacity: 0.7;
    bottom: 8%;
    left: 5.5%;
    border-radius: 15px;
}

.qrCodeShow {
    position: absolute;
    top: 15%;
    width: 70%;
    height: 50%;
    right: 15%;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 15px;
}
.selectUser{
  bottom: 10rem;
  top: unset;
}
</style>
